export enum MakeVaperAgreement {
    AGREE = 0 ,
    ALMOST_AGREE = 1,
    DISAGREE = 2
}